<template>
    <v-card min-height="500px" class="ma-auto">
        <v-col sm="12" md="12" lg="12" class="ma-auto grey lighten-5">
            <v-img
                v-if="usuarioPartner"
                class="ma-auto"
                align-center
                justify-center
                :src="logoBvs"
                width="20vw"
                alt="logo-recuperi"
            />
            <v-img
                v-if="!usuarioPartner"
                class="ma-auto"
                align-center
                justify-center
                :src="logo"
                width="12vw"
                alt="logo-recuperi"
            />
        </v-col>
        <v-col sm="12" md="8" lg="8" class="ma-auto">
            <p class="text-justify mt-8">
                Olá {{ nomeDevedor }}, Identificamos que você possui débitos com
                {{ nomeExibicaoApresentante }}, esse valor será encaminhado a
                protesto em breve.
            </p>
            <p class="text-justify">
                Para evitar restrições em seu nome, entre em contato com
                {{ nomeExibicaoApresentante }} e negocie suas dívidas com
                antecedência.
            </p>
            <p class="text-center font-weight-black">
                Valor em Protesto: R$
                {{ saldoProtestoFormatado }}
            </p>
        </v-col>
        <v-col sm="12" md="12" lg="12" class="ma-auto text-center">
            <v-btn color="primary" class="ma-auto">
                Desejo Negociar minha dívida
            </v-btn>
        </v-col>
        <v-col sm="12" md="12" lg="12" class="ma-auto text-center">
            Obrigado, Equipe Recuperi
        </v-col>
        <v-col sm="12" md="12" lg="12" class="text-center grey lighten-5">
            <p class="font-weight-light subtitle-2">
                Observação: Essa é uma prévia do e-mail enviado, utilizamos esse
                modelo para envio a todos os devedores
            </p>
            <v-btn
                small
                color="grey lighten-3"
                class="ma-auto"
                @click="fecharModal"
            >
                Fechar
            </v-btn>
        </v-col>
    </v-card>
</template>

<script>
export default {
    name: 'Template220',
    props: {
        usuarioPartner: {
            type: Boolean,
            default: false,
            required: true
        },
        nomeDevedor: {
            type: String,
            default: ''
        },
        nomeExibicaoApresentante: {
            type: String,
            default: ''
        },
        saldoProtestoFormatado: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            logo: require('@/assets/logo_recuperi_azul_escura.png')
        };
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModal', false);
        }
    }
};
</script>

<style></style>
